
import { Options, Vue } from "vue-class-component";
import BarChart from "./charts/bar-chart.vue"
@Options({
  components: {
    BarChart
  }
})
export default class SectionTotalCourierInvalidDex extends Vue {}
